var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1717_30523)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.646 2.94141C9.52692 2.94141 2.9375 9.53082 2.9375 17.6499C2.9375 25.769 9.52692 32.3584 17.646 32.3584C25.7651 32.3584 32.3545 25.769 32.3545 17.6499C32.3545 9.53082 25.7651 2.94141 17.646 2.94141ZM17.646 7.35396C20.0876 7.35396 22.0586 9.3249 22.0586 11.7665C22.0586 14.2081 20.0876 16.1791 17.646 16.1791C15.2044 16.1791 13.2335 14.2081 13.2335 11.7665C13.2335 9.3249 15.2044 7.35396 17.646 7.35396ZM17.646 28.2401C13.9689 28.2401 10.7183 26.3574 8.82091 23.5039C8.86503 20.5769 14.7043 18.9737 17.646 18.9737C20.573 18.9737 26.427 20.5769 26.4711 23.5039C24.5737 26.3574 21.3232 28.2401 17.646 28.2401Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1717_30523"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.3004,
    height: 35.3004,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.71a873bd25bfe2ee2d8dde8640819af3.svg";
export { ForwardRef as ReactComponent };